import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DDLModes } from '../../../components/ui/controls/ddl-input/ddl-input.component';
import { TextModes } from '../../../components/ui/controls/text-input/text-input.component';
import { OrderDetails } from '../../../models/orders/orderDetails';
import { TransactionType, TransactionTypeVerb } from '../../../core/constants';
import { RecurringSchedule } from '../../../models/recurringPayments/recurringSchedule';
import { L2L3Data } from '../../../models/orders/L2L3Data';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-terminal-order',
  templateUrl: './terminal-order.component.html',
  standalone: false,
})
export class TerminalOrderComponent {
  @Input() level2Level3PaneExpanded: boolean = false;
  @Input() hidden: boolean = false;
  @Input() orderDetails: Partial<OrderDetails>;
  @Input() allowChargeAmountChange: boolean = true;
  @Output() onTransactionTypeChanged = new EventEmitter<TransactionType>();
  @Output() onChargeAmountChanged = new EventEmitter<number|undefined>();
  @Output() onRecurringUpdate = new EventEmitter<RecurringSchedule>();

  IconType = IconType;
  InputTextModes = TextModes;
  DDLModes = DDLModes;
  TransactionType = TransactionType;
  TransactionTypeVerb = TransactionTypeVerb;

  L2L3Data: Partial<L2L3Data> = L2L3Data.createEmpty();


  transactionTypeOptions: ListItem[] = [];

  constructor() {
    this.orderDetails = OrderDetails.createEmpty();

    this.transactionTypeOptions.push(new ListItem({ id: TransactionType.TRANSACTION_TYPE_AUTHCAPTURE.toString(), name: 'Sale' }));
    this.transactionTypeOptions.push(new ListItem({ id: TransactionType.TRANSACTION_TYPE_AUTH.toString(), name: 'Authorize' }));
    this.transactionTypeOptions.push(new ListItem({ id: TransactionType.TRANSACTION_TYPE_RECUR.toString(), name: 'Recurring' }));
  
  }

  handleDescriptionChanged(description: string) {
    this.orderDetails.description = description;
  }

  handleRecipientEmailChanged(recipientEmail: string) {
    this.orderDetails.recipientEmail = recipientEmail;
  }

  handleInvoiceNumberChanged(invoiceNumber: string) {
    this.orderDetails.invoiceNumber = invoiceNumber;
  }

  handlePoNumberChanged(poNumber: string) {
    this.orderDetails.poNumber = poNumber;
  }

  handleTransactionTypeChanged() {
    if (
      Number(this.orderDetails.transactionType) ===
      TransactionType.TRANSACTION_TYPE_RECUR
    ) {
      this.orderDetails.recurringSchedule ??= new RecurringSchedule({});
    }
    this.onTransactionTypeChanged.emit(
      Number(this.orderDetails.transactionType) as TransactionType,
    );
  }

  handleRecurringUpdate(recurringSchedule: RecurringSchedule) {
    this.orderDetails.recurringSchedule = recurringSchedule;
    console.log("Recurring schedule updated: ", this.orderDetails.recurringSchedule);
    this.onRecurringUpdate.emit(recurringSchedule);
  }

  txtChargeAmount_keyup() {
    this.onChargeAmountChanged.emit(this.orderDetails.totalAmount);
  }

  clear() {
    this.orderDetails = OrderDetails.createEmpty();
  }
}
